import React from 'react';

const Languages = React.lazy(() => import('pages/System/Languages'));

//Main Route
const Dashboard = React.lazy(() => import('components/Dashboard'));
const MemberManage = React.lazy(() => import('pages/Member/MemberManage'));
const MemberProfile = React.lazy(() => import('pages/Member/MemberManage/MemberProfile'));
const MemberCoinPayment = React.lazy(() => import('pages/Member/MemberManage/MemberCoinPayment'));
const MemberCensorship = React.lazy(() => import('pages/Member/MemberCensorship'));
const MemberImageDetail = React.lazy(() => import('pages/Member/MemberCensorship/MemberImage'));
const Payment = React.lazy(() => import('pages/Payment'));
const VerifyChat = React.lazy(() => import('pages/Chat/VerifyChat'));
const ConversationChat = React.lazy(() => import('pages/Chat/Conversation'));
const Contact = React.lazy(() => import('pages/Contact'));
const Report = React.lazy(() => import('pages/Report'));
const Notification = React.lazy(() => import('pages/Notification'));

// const Shipping = React.lazy(() => import('pages/Shipping'));
// const Shopping = React.lazy(() => import('pages/Shopping'));
// const ShoppingOrderDetail = React.lazy(() => import('pages/Shopping/OrderDetail'));
// const RequestPaymentOrder = React.lazy(() => import('pages/Shopping/RequestPaymentOrder'));
// const ImportWarehouse = React.lazy(() => import('pages/Shopping/ImportWarehouse'));
// const RequestPaymentSystemFee = React.lazy(() => import('pages/Shopping/RequestPaymentSystemFee'));
// const EditOrderInformation = React.lazy(() => import('pages/Shopping/EditOrderInformation'));
// const ImportWarehouseMultiple = React.lazy(() => import('pages/Shopping/ImportWarehouseMultiple'));
// const StockDeliveryMultiple = React.lazy(() => import('pages/Shopping/StockDeliveryMultiple'));

//Configs
const Roles = React.lazy(() => import('pages/System/Roles'));
// const Configs = React.lazy(() => import('pages/Configs'));
// const ConfigSystem = React.lazy(() => import('pages/ConfigSystem'));
const AccountProfile = React.lazy(() => import('pages/Profile/ChangeProfile'));
const ChangePassword = React.lazy(() => import('pages/Profile/ChangePassword'));
const Staff = React.lazy(() => import('pages/System/Staffs'));
const StaffCreate = React.lazy(() => import('pages/System/Staffs/StaffCreate'));
const StaffEdit = React.lazy(() => import('pages/System/Staffs/StaffEdit'));
const MaleBodyShape = React.lazy(() => import('pages/Resources/MaleBodyShape'));
const FemaleBodyShape = React.lazy(() => import('pages/Resources/FemaleBodyShape'));
const MalePersonality = React.lazy(() => import('pages/Resources/MalePersonality'));
const FemalePersonality = React.lazy(() => import('pages/Resources/FemalePersonality'));
const MaleSociability = React.lazy(() => import('pages/Resources/MaleSociability'));
const FemaleSociability = React.lazy(() => import('pages/Resources/FemaleSociability'));
const Education = React.lazy(() => import('pages/Resources/Education'));
const Holiday = React.lazy(() => import('pages/Resources/Holiday'));
const Occupation = React.lazy(() => import('pages/Resources/Occupation'));
const Liquor = React.lazy(() => import('pages/Resources/Liquor'));
const Tobacco = React.lazy(() => import('pages/Resources/Tobacco'));
const BloodType = React.lazy(() => import('pages/Resources/BloodType'));
const MarriageHistory = React.lazy(() => import('pages/Resources/MarriageHistory'));
const Housemate = React.lazy(() => import('pages/Resources/Housemate'));
const LanguageUse = React.lazy(() => import('pages/Resources/LanguageUse'));
const FirstDateCost = React.lazy(() => import('pages/Resources/FirstDateCost'));
const PossibleMove = React.lazy(() => import('pages/Resources/PossibleMove'));
const FocusFinding = React.lazy(() => import('pages/Resources/FocusFinding'));
const HopeMeet = React.lazy(() => import('pages/Resources/HopeMeet'));
const Ken = React.lazy(() => import('pages/Resources/Ken'));
const Question = React.lazy(() => import('pages/Resources/Question'));
const ReportResource = React.lazy(() => import('pages/Resources/Report'));
const ContactResource = React.lazy(() => import('pages/Resources/Contact'));
const OutGroup = React.lazy(() => import('pages/Resources/OutGroup'));
const OS = React.lazy(() => import('pages/Resources/OS'));
const Income = React.lazy(() => import('pages/Resources/Income'));
const FAQ = React.lazy(() => import('pages/Resources/FAQ'));
const NGWord = React.lazy(() => import('pages/Resources/NGWord'));

//Config
const ConfigsSystem = React.lazy(() => import('pages/Configs/ConfigsSystem'));
const ConfigsAdmin = React.lazy(() => import('pages/Configs/ConfigsAdmin'));

//Package
const LikePackage = React.lazy(() => import('pages/Package/LikePackage'));
const BoostPackage = React.lazy(() => import('pages/Package/BoostPackage'));

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/member/member-manage', name: 'Member Manage', component: MemberManage },
  { path: '/member/profile/:memberId', exact: true, name: 'Member Profile', component: MemberProfile },
  { path: '/member/payment/:memberId', exact: true, name: 'Member Coin Payment', component: MemberCoinPayment },
  { path: '/member/member-censorship', exact: true, name: 'Member Censorship', component: MemberCensorship },
  { path: '/member/member-censorship/:memberId', exact: true, name: 'Member Image', component: MemberImageDetail },

  { path: '/payment', exact: true, name: 'Payment', component: Payment },
  { path: '/chat/chat-verify', exact: true, name: 'Verify chat', component: VerifyChat },
  { path: '/chat/chat-conversation', exact: true, name: 'Conversation chat', component: ConversationChat },
  { path: '/contact', exact: true, name: 'Contact', component: Contact },
  { path: '/report', exact: true, name: 'Report', component: Report },
  { path: '/notification', exact: true, name: 'Notification', component: Notification },

  // { path: '/shipping', name: 'Theme', component: Shipping, exact: true },
  // { path: '/shopping', name: 'Theme', component: Shopping, exact: true },
  { path: '/roles', name: 'Roles', component: Roles, exact: true },
  { path: '/languages', name: 'Languages', component: Languages },
  // { path: '/configs', name: 'Configs', component: Configs },
  // { path: '/config-system', name: 'Config System', component: ConfigSystem },
  // { path: '/config-domestic', name: 'Config System', component: ConfigDomestic },
  { path: '/account/profile', name: 'Account Profile', component: AccountProfile },
  { path: '/account/change-password', name: 'Account Profile', component: ChangePassword },
  { path: '/staffs', exact: true, name: 'Staff', component: Staff },
  { path: '/staffs/create', exact: true, name: 'Staff Create', component: StaffCreate },
  { path: '/staffs/edit/:staffId', exact: true, name: 'Staff Edit', component: StaffEdit },
  //Resource
  { path: '/resources/male-body-shape', exact: true, name: 'Male Shape Body', component: MaleBodyShape },
  { path: '/resources/female-body-shape', exact: true, name: 'Female Shape Body', component: FemaleBodyShape },
  { path: '/resources/male-personality', exact: true, name: 'Male Personality', component: MalePersonality },
  { path: '/resources/female-personality', exact: true, name: 'Female Personality', component: FemalePersonality },
  { path: '/resources/male-sociability', exact: true, name: 'Male Sociability', component: MaleSociability },
  { path: '/resources/female-sociability', exact: true, name: 'Female Sociability', component: FemaleSociability },
  { path: '/resources/education', exact: true, name: 'Female Sociability', component: Education },
  { path: '/resources/holiday', exact: true, name: 'Holiday', component: Holiday },
  { path: '/resources/occupation', exact: true, name: 'Occupation', component: Occupation },
  { path: '/resources/liquor', exact: true, name: 'Liquor', component: Liquor },
  { path: '/resources/tobacco', exact: true, name: 'Tobacco', component: Tobacco },
  { path: '/resources/blood-type', exact: true, name: 'Blood Type', component: BloodType },
  { path: '/resources/marriage-history', exact: true, name: 'Marriage History', component: MarriageHistory },
  { path: '/resources/housemate', exact: true, name: 'Housemate', component: Housemate },
  { path: '/resources/language-to-use', exact: true, name: 'Language To Use', component: LanguageUse },
  { path: '/resources/first-date-cost', exact: true, name: 'First Date Cost', component: FirstDateCost },
  { path: '/resources/possible-move', exact: true, name: 'Possible Move', component: PossibleMove },
  { path: '/resources/focus-finding', exact: true, name: 'Focus Finding', component: FocusFinding },
  { path: '/resources/hope-meet', exact: true, name: 'Hope Meet', component: HopeMeet },
  { path: '/resources/ken', exact: true, name: 'Ken', component: Ken },
  { path: '/resources/question', exact: true, name: 'Question', component: Question },
  { path: '/resources/report', exact: true, name: 'Report Resource', component: ReportResource },
  { path: '/resources/contact', exact: true, name: 'Contact Resource', component: ContactResource },
  { path: '/resources/out-group', exact: true, name: 'Out Group', component: OutGroup },
  { path: '/resources/os', exact: true, name: 'OS', component: OS },
  { path: '/resources/income', exact: true, name: 'Income', component: Income },
  { path: '/resources/FAQ', exact: true, name: 'FAQ', component: FAQ },
  { path: '/resources/ng-word', exact: true, name: 'NG word', component: NGWord },

  //Configs
  { path: '/configs-system', exact: true, name: 'Configs System', component: ConfigsSystem },
  { path: '/configs-admin', exact: true, name: 'Configs Admin', component: ConfigsAdmin },
  //Package
  { path: '/like-package', exact: true, name: 'Like Package', component: LikePackage },
  { path: '/boost-package', exact: true, name: 'Like Package', component: BoostPackage },
];

export default routes;
